var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseTiny = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 15,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E4E4E4",
  d: "m11.083 4.24-.822-.823L7 6.677l-3.262-3.26-.822.822L6.177 7.5l-3.26 3.261.822.823L7 8.323l3.26 3.26.823-.822-3.26-3.26z"
})));
export default SvgCloseTiny;